module.exports = __webpack_public_path__ + "mc.svg?37be4651b8d058120dd8cb47983e9c99";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/mc.svg
// module id = 1484
// module chunks = 0